import {
  ICreateDriverResponse,
  ICreateDriversBody,
  IUpload,
} from "../../utils/types";
import { apiManager } from "../api-manager";

export const createDriver = async ({
  fullName,
  email,
  password,
  phone,
  vehicleNumber,
  profileImage,
  drivingLicenseFile,
  zipCode,
  vehicleType,
  vehicleMake,
  vehicleModel,
  vehicleMakeYear,
  driverLicenseNumber,
  driverLicenseState,
  dob,
  state,
  vehicleInsuranceFile,
}: ICreateDriversBody) => {
  const fd = new FormData();
  const fd2 = new FormData();
  const fd3 = new FormData();
  let res;
  let res2;

  fd.append("file", profileImage);
  fd.append("type", "profilePhoto");
  fd.append("userType", "driver");
  fd.append("email", email);
  res2 = await apiManager.post<IUpload>("/upload", fd);
  let profileImageUrl;
  if (res2.success) {
    profileImageUrl = res2?.data?.Location;
  }

  fd3.append("file", drivingLicenseFile);
  fd3.append("type", "drivingLicense");
  fd3.append("userType", "driver");
  fd3.append("email", email);
  const res4 = await apiManager.post<IUpload>("/upload", fd3);
  let drivingLicenseUrl;
  if (res4.success) {
    drivingLicenseUrl = res4?.data?.Location;
  }

  fd2.append("file", vehicleInsuranceFile);
  fd2.append("type", "vehicleInsurance");
  fd2.append("userType", "driver");
  fd2.append("email", email);
  const res3 = await apiManager.post("/upload", fd2);
  let vehicleInsuranceFileUrl;
  if (res3.success) {
    vehicleInsuranceFileUrl = res3?.data?.Location;
  }

  res = await apiManager.post<ICreateDriverResponse>("/admin/driver/create", {
    fullName,
    email,
    password,
    phone,
    vehicleNumber,
    profileImage: profileImageUrl,
    drivingLicenseFile: drivingLicenseUrl,
    zipCode,
    vehicleType,
    vehicleMake,
    vehicleModel,
    vehicleMakeYear,
    dob,
    driverLicenseNumber,
    driverLicenseState,
    state,
    vehicleInsuranceFile: vehicleInsuranceFileUrl,
  });
  return res;
};
